import * as yup from 'yup';

export const personalSchema = yup.object().shape({
  firstName: yup.string().required('First name is required'),
  lastName: yup.string().required('Last name is required'),
  email: yup.string().email('Invalid email').required('Email is required'),
  phone: yup.string().required('Phone number is required'),
  gender: yup.string().required('Gender is required'),
  address1: yup.string().required('Address 1 is required'),
  address2: yup.string().notRequired(),
  suburb: yup.string().required('Suburb is required'),
  state: yup.string().required('State is required'),
  postcode: yup.string().required('Postcode is required')
});

// export const bankAndSuperSchema = yup.object().shape({
//   paymentMethod: yup.string().required('Payment method is required'),
//   accountName: yup.string().when('paymentMethod', {
//     is: (val: string) => val === 'Bank',
//     then: (schema) => schema.required('Account name is required'),
//     otherwise: (schema) => schema.notRequired()
//   }),
//   bank: yup.string().when('paymentMethod', {
//     is: (val: string) => val === 'Bank',
//     then: (schema) => schema.required('Bank is required'),
//     otherwise: (schema) => schema.notRequired()
//   }),
//   bsb: yup.string().when('paymentMethod', {
//     is: (val: string) => val === 'Bank',
//     then: (schema) => schema.required('BSB is required').length(6, 'BSB must be 6 digits'),
//     otherwise: (schema) => schema.notRequired()
//   }),
//   accountNumber: yup.string().when('paymentMethod', {
//     is: (val: string) => val === 'Bank',
//     then: (schema) =>
//       schema.required('Account number is required').min(6, 'Min 6 digits').max(10, 'Max 10 digits'),
//     otherwise: (schema) => schema.notRequired()
//   }),
//   superFundType: yup.string().required('Super fund type is required'),
//   superContributionRate: yup.string().required('Super contribution rate is required'),
//   superCompany: yup.string().required('Super company is required')
// });

export const bankAndSuperSchema = yup.object().shape({
  paymentMethod: yup.string().required('Payment method is required'),
  accountName: yup.string().when('paymentMethod', {
    is: (val: string) => val === 'Bank',
    then: (schema) => schema.required('Account name is required'),
    otherwise: (schema) => schema.notRequired()
  }),
  bank: yup.string().when('paymentMethod', {
    is: (val: string) => val === 'Bank',
    then: (schema) => schema.required('Bank is required'),
    otherwise: (schema) => schema.notRequired()
  }),
  bsb: yup.string().when('paymentMethod', {
    is: (val: string) => val === 'Bank',
    then: (schema) => schema.required('BSB is required').length(6, 'BSB must be 6 digits'),
    otherwise: (schema) => schema.notRequired()
  }),
  accountNumber: yup.string().when('paymentMethod', {
    is: (val: string) => val === 'Bank',
    then: (schema) =>
      schema.required('Account number is required').min(6, 'Min 6 digits').max(10, 'Max 10 digits'),
    otherwise: (schema) => schema.notRequired()
  }),
  superFundType: yup.string().required('Super fund type is required'),
  superContributionRate: yup.string().required('Super contribution rate is required'),
  superCompany: yup.string().required('Super company is required'),
  smsfsName: yup.string().when('superFundType', {
    is: (val: string) => val === 'Self managed super fund',
    then: (schema) => schema.required('SMSF name is required'),
    otherwise: (schema) => schema.notRequired()
  }),
  smsfsAbn: yup.string().when('superFundType', {
    is: (val: string) => val === 'Self managed super fund',
    then: (schema) => schema.required('SMSF ABN is required').length(11, 'ABN must be 11 digits'),
    otherwise: (schema) => schema.notRequired()
  }),
  electronicServiceAddress: yup.string().when('superFundType', {
    is: (val: string) => val === 'Self managed super fund',
    then: (schema) =>
      schema.required('Electronic service address is required').email('Invalid email'),
    otherwise: (schema) => schema.notRequired()
  }),
  employerNumber: yup.string().when('superFundType', {
    is: (val: string) => val === 'Self managed super fund',
    then: (schema) => schema.notRequired(),
    otherwise: (schema) => schema.notRequired()
  }),
  smsfsBankAccountName: yup.string().when('superFundType', {
    is: (val: string) => val === 'Self managed super fund',
    then: (schema) => schema.required('SMSF bank account name is required'),
    otherwise: (schema) => schema.notRequired()
  }),
  smsfsBsb: yup.string().when('superFundType', {
    is: (val: string) => val === 'Self managed super fund',
    then: (schema) => schema.required('SMSF BSB is required').length(6, 'BSB must be 6 digits'),
    otherwise: (schema) => schema.notRequired()
  }),
  smsfsAccountNumber: yup.string().when('superFundType', {
    is: (val: string) => val === 'Self managed super fund',
    then: (schema) =>
      schema
        .required('SMSF account number is required')
        .min(6, 'Min 6 digits')
        .max(10, 'Max 10 digits'),
    otherwise: (schema) => schema.notRequired()
  })
});


export const employmentSchema = yup.object().shape({
  jobTitle: yup.string().required('Job title is required'),
  startDate: yup.date().required('Start date is required').nullable(),
  employmentType: yup.string().required('Employment type is required'),
  weeklyWorkHours: yup.number().required('Weekly work hours are required').min(0),
  roles: yup.string().optional(),
  payPeriod: yup.string().required('Pay period is required'),
  leaveLoading: yup.number().required('Leave loading is required').min(0).max(100)
});

export const payRatesSchema = yup.object({
  basePayRate: yup
    .string()
    .transform((value) => (value === '' ? undefined : value))
    .required('Base pay rate is required'),
  basePayRateType: yup.string().oneOf(['hour', 'day']).required('Base pay rate type is required'),
  saturdayRate: yup
    .string()
    .transform((value) => (value === '' ? undefined : value))
    .required('Saturday rate is required'),
  saturdayRateType: yup.string().oneOf(['hour', 'day']).required('Saturday rate type is required'),
  sundayRate: yup
    .string()
    .transform((value) => (value === '' ? undefined : value))
    .required('Sunday rate is required'),
  sundayRateType: yup.string().oneOf(['hour', 'day']).required('Sunday rate type is required'),
  publicHolidayRate: yup
    .string()
    .transform((value) => (value === '' ? undefined : value))
    .required('Public holiday rate is required'),
  publicHolidayRateType: yup
    .string()
    .oneOf(['hour', 'day'])
    .required('Public holiday rate type is required'),
  additionalPublicHoliday: yup
    .string()
    .transform((value) => (value === '' ? undefined : value))
    .required('Additional public holiday rate is required'),
  additionalPublicHolidayRateType: yup
    .string()
    .oneOf(['hour', 'day'])
    .required('Additional public holiday rate type is required'),
  nightShiftRate: yup
    .string()
    .transform((value) => (value === '' ? undefined : value))
    .required('Night shift rate is required'),
  nightShiftRateType: yup
    .string()
    .oneOf(['hour', 'day'])
    .required('Night shift rate type is required'),
  nightShiftStartTime: yup
    .string()
    .transform((value) => (value === '' ? undefined : value))
    .required('Night shift start time is required'),
  nightShiftEndTime: yup
    .string()
    .transform((value) => (value === '' ? undefined : value))
    .required('Night shift end time is required'),
  holidays: yup
    .array()
    .of(
      yup.object({
        id: yup.number().required(),
        name: yup.string().required(),
        date: yup.string().required(),
        enabled: yup.boolean().required()
      })
    )
    .required()
});

export const taxSchema = yup.object({
  dateOfBirth: yup.string().required('Date of birth is required'),
  statusOfResidency: yup.string().required('Status of residency is required'),
  incomeType: yup.string().required('Income type is required'),
  tfnExemption: yup.string().required('TFN exemption is required'),
  taxFileNumber: yup.string().optional(),
  claimTaxFreeThreshold: yup.boolean().required(),
  hasStudyAndTrainingLoan: yup.boolean().required(),
  isHorticulturistOrShearer: yup.boolean().required(),
  hasChildSupportObligations: yup.boolean().required()
});

export const openingBalancesSchema = yup.object().shape({
  asAtDate: yup.date().nullable(),
  leaveBalances: yup.object().shape({
    annualLeaveBalance: yup.number().min(0).nullable(),
    sickLeaveBalance: yup.number().min(0).nullable()
  }),
  ordinaryEarnings: yup.object().shape({
    ordinaryTimeEarnings: yup.number().min(0).nullable(),
    superGuarantee: yup.number().min(0).nullable(),
    tax: yup.number().min(0).nullable(),
    bonusesCommission: yup.number().min(0).nullable(),
    directorsFee: yup.number().min(0).nullable(),
    employerContributionsRESC: yup.number().min(0).nullable(),
    superSalarySacrifice: yup.number().min(0).nullable(),
    reimbursement: yup.number().min(0).nullable(),
    overtime: yup.number().min(0).nullable()
  }),
  paidLeave: yup.object().shape({
    annualLeave: yup.number().min(0).nullable(),
    sickLeave: yup.number().min(0).nullable(),
    longServiceLeave: yup.number().min(0).nullable(),
    paidParentalLeave: yup.number().min(0).nullable(),
    ancillaryAndDefenceLeave: yup.number().min(0).nullable(),
    workersCompensation: yup.number().min(0).nullable()
  }),
  allowance: yup.object().shape({
    awardTransportPayments: yup.number().min(0).nullable(),
    centsPerKM: yup.number().min(0).nullable(),
    laundry: yup.number().min(0).nullable(),
    overtimeMeal: yup.number().min(0).nullable(),
    qualifications: yup.number().min(0).nullable(),
    task: yup.number().min(0).nullable(),
    tool: yup.number().min(0).nullable(),
    travel: yup.number().min(0).nullable(),
    jobKeeperTopUp: yup.number().min(0).nullable(),
    otherGeneral: yup.number().min(0).nullable(),
    otherHomeOffice: yup.number().min(0).nullable(),
    otherNonDeductible: yup.number().min(0).nullable(),
    otherTransportFares: yup.number().min(0).nullable(),
    otherUniform: yup.number().min(0).nullable(),
    otherPrivateVehicle: yup.number().min(0).nullable()
  }),
  deductions: yup.object().shape({
    preTaxFees: yup.number().min(0).nullable(),
    preTaxWorkplaceGiving: yup.number().min(0).nullable(),
    postTaxFees: yup.number().min(0).nullable(),
    postTaxWorkplaceGiving: yup.number().min(0).nullable(),
    childSupportGarnishees: yup.number().min(0).nullable(),
    childSupportDeductions: yup.number().min(0).nullable()
  }),
  fringeBenefits: yup.object().shape({
    fringeBenefitsTaxable: yup.number().min(0).nullable()
  })
});

export const templateSchema = yup.object().shape({
  ordinaryTimeEarnings: yup
    .object()
    .shape({
      hours: yup
        .number()
        .min(0)
        .nullable()
        .transform((value) => (isNaN(value) ? null : value)),
      amount: yup
        .number()
        .min(0)
        .nullable()
        .transform((value) => (isNaN(value) ? null : value))
    })
    .optional(),
  earnings: yup
    .array()
    .of(
      yup.object().shape({
        type: yup.string(),
        exemptFromSuper: yup.boolean(),
        amount: yup
          .number()
          .min(0)
          .nullable()
          .transform((value) => (isNaN(value) ? null : value))
      })
    )
    .optional(),
  extraHours: yup
    .array()
    .of(
      yup.object().shape({
        option: yup.string(),
        name: yup.string(),
        hours: yup
          .number()
          .min(0)
          .nullable()
          .transform((value) => (isNaN(value) ? null : value)),
        rate: yup
          .number()
          .min(0)
          .nullable()
          .transform((value) => (isNaN(value) ? null : value))
      })
    )
    .optional(),
  allowances: yup
    .array()
    .of(
      yup.object().shape({
        unit: yup
          .number()
          .min(0)
          .nullable()
          .transform((value) => (isNaN(value) ? null : value)),
        rate: yup
          .number()
          .min(0)
          .nullable()
          .transform((value) => (isNaN(value) ? null : value)),
        option: yup.string(),
        type: yup.string()
      })
    )
    .optional(),
  deductions: yup
    .array()
    .of(
      yup.object().shape({
        option: yup.string(),
        type: yup.string(),
        rate: yup
          .number()
          .min(0)
          .nullable()
          .transform((value) => (isNaN(value) ? null : value))
      })
    )
    .optional(),
  childSupport: yup
    .array()
    .of(
      yup.object().shape({
        type: yup.string(),
        rate: yup
          .number()
          .min(0)
          .nullable()
          .transform((value) => (isNaN(value) ? null : value))
      })
    )
    .optional(),
  superannuation: yup
    .object()
    .shape({
      employerContribution: yup
        .number()
        .min(0)
        .nullable()
        .transform((value) => (isNaN(value) ? null : value)),
      superSalarySacrifice: yup
        .number()
        .min(0)
        .nullable()
        .transform((value) => (isNaN(value) ? null : value)),
      isPercentage: yup.boolean()
    })
    .optional(),
  fixedTaxAmount: yup
    .object()
    .shape({
      enabled: yup.boolean(),
      amount: yup
        .number()
        .min(0)
        .nullable()
        .transform((value) => (isNaN(value) ? null : value))
    })
    .optional()
});

export const employeeDetailsSchema = yup.object().shape({
    jobTitle: yup.string().required('Job title is required'),
    startDate: yup.string()
      .nullable()
      .matches(
        /^\d{4}-\d{2}-\d{2}$/,
        { message: 'Start date must be in YYYY-MM-DD format', excludeEmptyString: true }
      ),
    employmentType: yup.string().required('Employment type is required'),
    weeklyWorkHours: yup.string().required('Weekly work hours are required'),
    roles: yup.string().nullable(),
    payPeriod: yup.string().required('Pay period is required'),
    leaveLoading: yup.string().required('Leave loading is required')
  });
